import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

const itemDetails = {
  pluralName: "billing_dashboards",
  singularName: "billing_dashboard",
};

export interface WorkOrderLineItem {
  id: string;
  item_date: string;
  description: string;
  line_item_id: string;
  rate: string;
  quantity: string;
  total: string;
}

export interface CompletedWorkOrder {
  id: string;
  name: string;
  description: string;
  start_date: string;
  submitted_date: string;
  status: string;
  client: string;
  client_field: string;
  client_field_id: string;
  acres: string;
  commodity: string;
  commodity_color: string;
  commodity_id: string;
  total: string;
  work_order_line_items: WorkOrderLineItem[];
}

interface BillingDashboardState {
  completedWorkOrders: CompletedWorkOrder[];
}

const state: BillingDashboardState = {
  completedWorkOrders: [],
};

const mutations = {
  LOAD_COMPLETED_WORK_ORDERS(
    state: BillingDashboardState,
    payload: CompletedWorkOrder[],
  ) {
    state.completedWorkOrders = payload;
  },
};

const actions = {
  needBillingDashboards(context: any, jsConn: JSConn) {
    return api
      .getItems(jsConn, itemDetails)
      .then(jsConn => {
        context.commit(
          "LOAD_COMPLETED_WORK_ORDERS",
          jsConn.response["completed_work_orders"],
        );
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  completedWorkOrders: (state: BillingDashboardState) =>
    state.completedWorkOrders,
};

const billingDashboardModule = {
  state,
  mutations,
  actions,
  getters,
};

export default billingDashboardModule;
